import { forwardRef, createElement } from 'react';

function IconPersonPlus(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M10.5 11.5c1.486 0 2.751.31 3.796.928-.462.29-.881.644-1.246 1.047-.726-.32-1.574-.475-2.55-.475-3.37 0-5.211 1.84-5.806 6.002a1.313 1.313 0 001.165 1.491l.134.007 6.31.001a6.027 6.027 0 001.23 1.5L5.992 22a2.813 2.813 0 01-2.784-3.21c.695-4.86 3.125-7.29 7.291-7.29zm7 1.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm0 1.5a.75.75 0 00-.743.648l-.007.102v1.5h-1.5a.75.75 0 00-.743.648l-.007.102c0 .38.282.693.648.743l.102.007h1.5v1.5c0 .38.282.693.648.743l.102.007a.75.75 0 00.743-.648l.007-.102v-1.5h1.5a.75.75 0 00.743-.648l.007-.102a.75.75 0 00-.648-.743l-.102-.007h-1.5v-1.5a.75.75 0 00-.648-.743L17.5 14.5zM10.5 2C12.433 2 14 3.903 14 6.25s-1.567 4.25-3.5 4.25S7 8.597 7 6.25 8.567 2 10.5 2zm0 1.5c-1.033 0-2 1.174-2 2.75S9.467 9 10.5 9s2-1.174 2-2.75-.967-2.75-2-2.75z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var PersonPlus = /*#__PURE__*/forwardRef(IconPersonPlus);

export default PersonPlus;
//# sourceMappingURL=PersonPlus.js.map
